import { Spin } from "antd";
import * as React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { IIndexTypeGroupDetailsPresenter } from "../../presenter/IndexTypeGroupDetailsPresenter";
import IndexTypeGrid from "../components/IndexTypeGrid";
import IndexTypeGroupSimpleGrid from "../components/IndexTypeGroupSimpleGrid";
import Text from "antd/lib/typography/Text";
export interface Props extends PageProps {}
export interface State extends IIndexTypeGroupDetailsPresenter {}

export default class IndexTypeGroupDetailsPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { indexTypeGroup, translate } = this.state;
    return (
      <Page {...this.props} className={"content-wrapper"}>
        <Spin spinning={this.state.loaders.indexTypeGroupLoader}>
          <div className={"content-main-title-wrapper"}>
            <Text className={"content-main-title"}>{indexTypeGroup.name}</Text>
            {indexTypeGroup.description && (
              <Text className={"content-main-title-description"}>
                {indexTypeGroup.description}
              </Text>
            )}
          </div>
          <br></br>
          <IndexTypeGrid
            translate={translate}
            indexTypes={indexTypeGroup.items}
          />
          <br></br>
          <IndexTypeGroupSimpleGrid
            translate={translate}
            indexTypeGroups={indexTypeGroup.childGroups}
          />
        </Spin>
      </Page>
    );
  }
}
